export default __webpack_public_path__ + "static/media/logocloudcasa.cf34ff9d.png";